import React from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { LayoutDashboard, FileText } from "lucide-react";

const NAV = [
  { to: "/app/affiliate", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/app/affiliate/statements", label: "Statements", icon: FileText },
];

export default function AffiliateLayout({ children }) {
  return (
    <DashboardLayout title="Afiliado" navItems={NAV}>
      {children}
    </DashboardLayout>
  );
}
